import {RouteRowMobile} from "./route-row-mobile";

export const RouteLineMobile = {
    props: {
        route: {
            type: Object,
            required: true,
        },
        current_day: {
            type: String,
            required: true,
        },
    },
    components: {
        RouteRowMobile,
    },
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    data(): object {
        return {}
    },
    computed: {},
    methods: {},
    template: `<div class="search-result-moblie__line">
            <RouteRowMobile
                :route_num="route.RouteNum"
                :route_name="route.RouteName"
                :route_bus="route.Bus"
                :route_carrier="route.Carrier"
                :route_departure_name="route.Departure.Name"
                :route_departure_time="route.DepartureTime"
                :route_arrival_name="route.Destination.Name"
                :route_arrival_time="route.ArrivalTime"
                :route_distance="route.Distance"
                :route_duration="route.Duration"
                :passenger_cost="route.PassengerFareCost"
                :free_seats="route.FreeSeatsAmount"
                :frequency="route.Frequency"
                :total_seats="route.FreeSeatsAmount"
                :destination_id="route.Destination.Id"
                :departure_id="route.Departure.Id"
                :trip_id="route.Id"
                :current_day="current_day"
                :status="route.Status"
                :status_print="route.StatusPrint"
                :status_reason="route.StatusReason"
            />
        </div>`,
}